// extracted by mini-css-extract-plugin
export default {"messageNotification":"Message_messageNotification__Cra2x"};